import { httpClient } from "@/app/old/desktop/shared/services/";
const API_HOST = process.env.VUE_APP_API_HOST;
let hosts = {
  core: `${API_HOST}/core/v1/resource`,
  therm: `${API_HOST}/therm/v1/resource`,
  terra: `${API_HOST}/terra/v1/resource`,
  vault: `${API_HOST}/vault/v1/resource`,
  forms: `${API_HOST}/forms/v1/resource`,
  system_model: `${API_HOST}/system-model/v1/resource`,
};
class API {
  constructor() {
    this.baseUrl = API_HOST;
  }
  async get_element_hierarchy(req = {}) {
    if (!req.stage || !hosts[req.stage.toLocaleLowerCase()])
      return Promise.reject(new Error("Invalid stage"));

    return httpClient({
      url: `/element/${req.id}/hierarchy/`,
      baseURL: hosts[req.stage.toLocaleLowerCase()],
      headers: req.headers,
    }).then(res => res.data);
  }

  async get_strategix4_data(req = {}) {
    return httpClient({
      url: `https://sensehawk-api.strategix4.com/api/streams/getstream/${
        req.query ? `?${req.query}` : ""
      }`,
      data: req.body,
      method: "POST",
    }).then(res => res.data);
  }
  async get_strategix4_token(req = {}) {
    return httpClient({
      url: `external/strategix4/auth/`,
      data: req.body,
      method: "POST",
      baseURL: hosts.core,
    }).then(res => res.data);
  }

  get_all_instances(req = {}) {
    return httpClient({
      url: `/instances/asset/${req.asset_uid}`,
      method: "GET",
      baseURL: hosts[req.stage.toLocaleLowerCase()],
    });
  }
  get_reference_vectors(req = {}) {
    return httpClient({
      url: `features/asset/${req.asset_id}/reference-vectors/`,
      baseURL: hosts.terra,
      method: "POST",
      data: req.body,
      headers: req.headers,
    });
  }
  get_element_for_instance(req = {}) {
    return httpClient({
      url: `/elements/instance/${req.instance_uid}`,
      method: "GET",
      baseURL: hosts[req.stage.toLocaleLowerCase()],
    });
  }
  async get(req = {}) {
    return httpClient({
      url: req.url,
      headers: req.headers,
    });
  }
  async get_strategix4_token(req = {}) {
    console.log(req);
    return httpClient({
      url: `external/strategix4/auth/`,
      data: req.body,
      method: "POST",
      baseURL: hosts.core,
    }).then(res => res.data);
  }
  async getTags(req = {}) {
    return httpClient({
      url: `${hosts.core}/tags/`,
      baseURL: hosts.core,
      headers: req.headers,
    }).then(res => res.data);
  }
  async post(req = {}) {
    return httpClient({
      url: req.url,
      data: req.body,
      headers: req.headers,
    });
  }
}
export const apiService = new API();
